var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 44,
    viewBox: "0 0 120 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 44,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.201,
    d: "M28 7h59v6H28zM28 31h78v6H28zM33 19h79v6H33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.12,
    d: "M8 7h16v6H8zM8 19h20v6H8zM8 31h16v6H8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactSet);
export default __webpack_public_path__ + "static/media/factSet.4a1852858856ad0ec8b70be260407f26.svg";
export { ForwardRef as ReactComponent };